module.exports = __webpack_public_path__ + "img/news15_1.281632de.png";